import React from 'react';
import { Button, ArrowLeftIcon, ArrowRightIcon } from '@uclaea/react-component-library';

interface PaginationControlsProps {
  currentPage: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({ currentPage, totalPages, onPrevious, onNext }) => (
  <div className="pagination-controls">
    <Button variant="secondary" label="Back" icon={{ left: ArrowLeftIcon }} onClick={onPrevious} disabled={currentPage === 0} />
    <span> Page {currentPage + 1} of {totalPages} </span>
    <Button variant="secondary" label="Next" icon={{ right: ArrowRightIcon }} onClick={onNext} disabled={currentPage === totalPages - 1} />
  </div>
);

export default PaginationControls;
